<template>
    <div class="entity-list">
        <entity-list-legend></entity-list-legend>
        <div class="fos-open-scouts">
            <div v-for="e in entities" v-bind:key=e.id>
                <entity :key="e.id" :entity="e"></entity>
            </div>
        </div>
        <entity-footer></entity-footer>
    </div>
</template>

<script>
  import EntityListLegend from './Legend.vue'
  import Entity from './Detail.vue'
  import EntityFooter from './Footer.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'EntityList',
    components: {Entity, EntityListLegend, EntityFooter},
    computed: mapGetters({
      entities: 'allEntities'
    }),
    created () {
      this.$store.dispatch('getAllEntities')
    }
  }
</script>

<style>
.icons--age {
    background-image: url('../../assets/images/age.svg');
    background-repeat: no-repeat;
}
.icons--operations {
    background-image: url('../../assets/images/time.svg');
    background-repeat: no-repeat;
}
.icons--district {
    background-image: url('../../assets/images/location.svg');
    background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/entities/List.vue